import { Component, OnInit } from '@angular/core';
import { Message } from '../../model/message.model';
import { TypeMenssage } from '../../model/type-menssage.model';
import { ToastService } from '../services/toast.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {

  messages: Array<any> = [];
  constructor(private toastService: ToastService) { }

  ngOnInit(): void {
  }

  Add(_message: string, type: TypeMenssage) {
    this.toastService.showToast(_message, type);
    this.messages.push(_message);
    /* let message = new Message(_message, type);
    this.messages.push(message);

    if (type == TypeMenssage.success)
      setTimeout(() => {
        this.messages = [];
      }, 10000);*/
  }

  AddWithoutTimeout(_message: string, type: TypeMenssage) {
    this.toastService.showToast(_message, type);
/*
    let message = new Message(_message, type);
    this.messages.push(message);*/
  }

  clear() {
    this.messages = [];
  }

}
